import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
  HttpEventType,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EXCLUDED_INTERCEPTORS_URLS, EXCLUDED_ERROR_REDIRECT_URLS } from './ExcludedHttpUrls';
import { SnackbarComponent } from '../components/shared/snackbar/snackbar.component';

@Injectable()
export class ApiCallsInterceptor implements HttpInterceptor {
  constructor(private router: Router, private snackBar: MatSnackBar) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        if (event.type === HttpEventType.Response) {
          const method = req.method;
          const url = req.url;

          // TODO -> cicababba! questo if é un accrocchio, trova il modo per non avere gli url cablati
          if (
            method !== 'GET' &&
            !EXCLUDED_INTERCEPTORS_URLS.some((exc) => url.endsWith(exc))
          ) {
            this.snackBar.openFromComponent(SnackbarComponent, {
              duration: 5000,
              horizontalPosition: 'center',
              verticalPosition: 'bottom',
              data: {
                message: 'Operazione effettuata con successo!',
                type: 'success',
              },
            });
          }
        }
      }),
      catchError((error: HttpErrorResponse) => {
        const url = req.url;
        const isTicketingUrl = EXCLUDED_ERROR_REDIRECT_URLS.some((exc) => url.includes(exc));

        // I 404 sono risposte attese in molti endpoint (es. intervista non presente):
        // non mostrare errore globale, lasciare la gestione al componente chiamante
        if (isTicketingUrl || error.status === 404) {
          return throwError(() => error);
        }

        const errorCode = error.error?.errorCode;
        const errorMessage = error.error?.errorMessage;

        let message: string;
        let skipRedirect = false;

        if (errorCode === 'E010') {
          message = 'Avviso legacy OpenAI: impossibile creare un agente RAG. Contattare il supporto.';
          skipRedirect = true;
        } else if (
          errorMessage ===
          'Cannot invoke "com.bycom.bandi.commons.model.Assistente.getAssistantId()" because "assistente" is null'
        ) {
          message = "Non è possibile accedere a questa funzionalità se per questo avviso non è stato creato l'assistant, contattare l'assistenza";
        } else {
          message = 'Si è verificato un errore. Riprova più tardi.';
        }

        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 7000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
          data: {
            message,
            type: 'error',
          },
        });
        console.log({ error });
        if (!skipRedirect) {
          this.router.navigate(['/error']);
        }

        return throwError(() => error);
      })
    );
  }
}
